module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAKlJREFUeAHt1kEKAjEMBdC0eIh2NzexnkSP5k2sJ7HL3qImKCJ/mQjO4j8Ik1X50ClJkoBSypZSulm/1jrNOYc4ZYlpWtu7mgREg/wMgyAGQQyCGAQxCGIQdLBRLs7JmXM+6vj/9HqWOPVUa33Ia4z/09jP1dhmJf6lpumGdrZGz7nq5y4+XSL0n7jo1S4r6yWAzxcxCGIQxCCIQRCDoP2sARLTtcZX7/YE6Csf6g/L1gcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/complaint/shangchuan.png
// module id = Zkmc
// module chunks = 1